import{jsx as e}from"react/jsx-runtime";import{forwardRef as t,useState as r,useContext as i}from"react";import{C as l}from"../Context/index.js";import s from"./styles.module.css";let Text=t((t,o)=>{let{text:n,size:a="default",bold:u,error:c,success:m,grey:d,inline:$,white:f,black:h,numberOfLines:x}=t,[g,p]=r(!1),T=i(l),v="light"===T.theme?s.light:s.dark,b=e=>{let t=e.currentTarget.scrollHeight>e.currentTarget.clientHeight;t&&p(!0)},k=()=>{switch(a){case"default":return s.default;case"s":return s.s;case"xs":return s.xs;default:return null}};return e("p",{ref:o,style:x?{WebkitLineClamp:x}:void 0,onMouseEnter:x?e=>b(e):void 0,onMouseLeave:()=>p(!1),title:g?n:void 0,className:`
        ${k()}
        ${u&&s.bold}
        ${c&&s.error}
        ${m&&s.success}
        ${d&&s.grey}
        ${f&&s.white}
        ${h&&s.black}
        ${$&&s.inline}
        ${x&&s.lineLimit}
        ${v}
      `,children:n})});export{Text as T};
